import { SolutionMap, SolutionOptionKey } from "@labs/shared/types/Solution.ts";
import { getSolutionValuePercent } from "./getSolutionValuePercent.ts";

export /**
 * Get the value of a solution option and convert from percentage to decimal
 */
const getSolutionValueDecimal = (
  solutionMap: SolutionMap,
  solutionKey: SolutionOptionKey,
) => getSolutionValuePercent(solutionMap, solutionKey) / 100;
